import React from 'react';
import { CloseHoc, SearchHoc } from '../../../assets/images';

const Search = (props = {}) => {

  /**
   * Following the states used in Search Component.
   *
   */

  const [typingValue, setTyping] = React.useState({typing:false});
  const searchTyping = React.useRef(null);

  /**
  * Following the states used in Search Component.
  *
  * @param {object} event to handle the searched element.
  */
  const searchFilterList = () => {
    let search = searchTyping;
    const value = search ? search.current.value : '';
    const { handleSearchFilterList } = props
    const searchWith = value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    setTyping({
      typing: value ? true : false
    })
    handleSearchFilterList(searchWith)
  }
  /**
   * clear search field
  */
 const clearSearch = () => {
   let search = searchTyping;
   search.current.value = '';
   searchFilterList()
  }

  /**
   * render() method to render the Search component into browser.
  */
 const { typing } = typingValue
    return (
      <div className="search">
        <input type="text" className="search-contacts" name="search-contacts" autoComplete="off" placeholder="Search" onChange={searchFilterList} ref={searchTyping}></input>
        <i className={(typing) ? '' : 'Search'} title="Search"> {!typing && <SearchHoc viewBox="0 0 14.201 14"/>}</i>
        <i className={(typing) ? 'CloseSearch' : ''} title="Clear search" onClick={clearSearch}>{typing && <CloseHoc viewBox="0 0 12 12" />}</i>
      </div>
    );
  }

export default Search;
